export function getDisplayTextForTitles(item, path): string {
  return null;
}

export const getAlternativeConvertedExperiment = (newPath, data) => false;
